import { settingApi } from '../../../slice/settingApi';

import type { ILabel } from '../labels.types';

const LABEL_API = {
  list: 'api/labels/list',
  add: 'api/labels',
  update: 'api/labels',
  details: 'api/labels/details',
  delete: 'api/labels',
};

export const labelApi = settingApi.injectEndpoints({
  endpoints: (builder) => ({
    // label list
    filterLabel: builder.mutation({
      query: (messageFilter) => ({
        url: LABEL_API.list,
        method: 'POST',
        body: messageFilter,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: { data?: { list?: ILabel[]; total?: number } }) => ({
        list: response?.data?.list ?? [],
        total: response?.data?.total ?? 0,
      }),
    }),

    createLabel: builder.mutation<ILabel, Partial<ILabel>>({
      query: (newLabel) => ({
        url: LABEL_API.add,
        method: 'POST',
        body: newLabel,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: { data?: { label: ILabel }; success: boolean }): ILabel =>
        response.success && response.data?.label ? response.data.label : ({} as ILabel),
    }),
    updateLabel: builder.mutation<ILabel, { id: string; updates: Partial<ILabel> }>({
      query: ({ id, updates }) => ({
        url: `${LABEL_API.update}/${id}`,
        method: 'PUT',
        body: updates,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    getLabelDtl: builder.mutation({
      query: (id: string) => ({
        url: `${LABEL_API.details}/${id}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: { data: ILabel }) => ({
        data: { label: response.data },
      }),
    }),
    deleteLabels: builder.mutation({
      query: (ids: string[]) => ({
        url: LABEL_API.delete,
        method: 'DELETE',
        body: { ids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
});

export const {
  useFilterLabelMutation,
  useCreateLabelMutation,
  useUpdateLabelMutation,
  useGetLabelDtlMutation,
  useDeleteLabelsMutation,
} = labelApi;
